import { NgModule } from '@angular/core';
import { FuseScrollbarDirective } from '@scientifica-cms-fe/directives/scrollbar/scrollbar.directive';

@NgModule({
    declarations: [
        FuseScrollbarDirective
    ],
    exports     : [
        FuseScrollbarDirective
    ]
})
export class FuseScrollbarModule
{
}
